<p-checkbox
  [id]="id"
  [(ngModel)]="isChecked"
  [binary]="true"
  [disabled]="disabled"
  (onChange)="onChange.emit($event)"
></p-checkbox>
